'use client';

import { useEffect } from 'react';
import { startLaunchDarklyBrowserObservability } from '@/client/observability/launchdarkly-browser';

export const LaunchDarklyObservabilityBootstrap = ({
    clientId,
    clientName,
}: {
    clientId: string;
    clientName?: string;
}) => {
    useEffect(() => {
        startLaunchDarklyBrowserObservability({ clientId, clientName });
    }, [clientId, clientName]);

    return null;
};
